import { jsx as _jsx } from "react/jsx-runtime";
import { BadgeAlert, Optional } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from './SpecialOfferCard.styles';
const StyledLoyaltyBadge = themeStyles.apply(BadgeAlert, 'StyledLoyaltyBadge');
// TODO: replace with dictionary key
const text = 'Loyalty Offer';
const LoyaltyBadge = ({ hasLoyaltyOffer = false }) => (_jsx(Optional, { when: hasLoyaltyOffer, children: _jsx(StyledLoyaltyBadge, { labelText: text, variant: "available" }) }));
export default LoyaltyBadge;
